<template>
  <el-table :data="list" stripe style="width: 100%">
    <el-table-column label="Изображение" width="120">
      <template slot-scope="scope">
        <img
          v-if="scope.row.image"
          alt="Running line icon"
          class="running-line-list__image"
          :src="scope.row.image"
        >
        <span v-else>—</span>
      </template>
    </el-table-column>
    <el-table-column label="Название (UA)" prop="title" width="200" />
    <el-table-column label="Название (RU)" prop="title_ru" width="200" />
    <el-table-column label="Ссылка" min-width="200" prop="url" />
    <el-table-column label="Позиция" prop="position" width="100" />
    <el-table-column label="Дата начала" width="180">
      <template slot-scope="scope">
        {{ formatDate(scope.row.start_at) }}
      </template>
    </el-table-column>
    <el-table-column label="Дата окончания" width="180">
      <template slot-scope="scope">
        {{ formatDate(scope.row.end_at) }}
      </template>
    </el-table-column>
    <el-table-column label="Активно" width="120">
      <template slot-scope="scope">
        <el-tag :type="scope.row.is_active ? 'success' : 'danger'">
          {{ scope.row.is_active ? 'Да' : 'Нет' }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column fixed="right" width="120">
      <template slot-scope="scope">
        <el-button
          size="small"
          type="success"
          @click="onEdit(scope.row.id)"
        >
          <i class="far fa-edit" />
        </el-button>

        <el-button
          size="small"
          type="danger"
          @click="onDelete(scope.row.id)"
        >
          <i class="far fa-trash-alt" />
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  name: 'List',
  computed: {
    ...mapState('runningLines', {
      list: 'runningLinesList',
    }),
  },
  methods: {
    ...mapActions('runningLines', [
      'deleteRunningLine',
      'fetchRunningLinesList',
    ]),
    onEdit(id) {
      this.$router.push({name: 'UpdateRunningLine', params: {id}})
    },
    async onDelete(id) {
      try {
        const res = await this.$confirm('Вы действительно хотите удалить эту бегущую строку?')
        if (res) {
          await this.deleteRunningLine(id)
          await this.fetchRunningLinesList()
        }
      } catch {
      }
    },
    formatDate(dateString) {
      // Convert date to local time in 'dd.MM.yyyy HH:mm' format
      if (!dateString) return '—'
      
      try {
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return dateString
        
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        
        return `${day}.${month}.${year} ${hours}:${minutes}`
      } catch (error) {
        console.error('Error formatting date:', error)
        return dateString
      }
    },
  },
}
</script>

<style lang="sass" scoped>
.running-line-list__image
  max-width: 50px
  max-height: 50px
  object-fit: contain
</style>


